// extracted by mini-css-extract-plugin
module.exports = {"content":"OrderingStatusAlert_content__scya9","compact":"OrderingStatusAlert_compact__QNnkT","overlay":"OrderingStatusAlert_overlay__9bpBh"};